// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"6edb02c1","326":"3d1efd34","345":"77211a7d","375":"3288469e","453":"c62e04aa","796":"465be5f8"}[chunkId] + ".chunk.js";
};